import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { KeyRound } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/faida`;

export const AdminWhiSettings = ({ adminKey }) => {
  const [s, setS] = useState(null);
  const [newKey, setNewKey] = useState('');
  const h = { headers: { 'X-Admin-Key': adminKey } };
  const load = () => axios.get(`${API}/partner-settings`, h).then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { if (adminKey) load(); }, [adminKey]); // eslint-disable-line react-hooks/exhaustive-deps

  const rotate = async () => {
    const r = await axios.post(`${API}/partner-key`, {}, h).catch(() => null);
    if (r) { setNewKey(r.data.partner_key); load(); }
  };
  if (!s) return null;
  return (
    <div className="mb-5 rounded-xl border border-slate-200 p-4" data-testid="admin-whi-settings">
      <p className="mb-2 text-sm font-semibold text-slate-900">Faida Fund hand-off to WHI</p>
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <button onClick={rotate} className="inline-flex items-center gap-1 rounded-lg border border-slate-300 px-3 py-1.5 font-semibold" data-testid="admin-whi-key-rotate">
          <KeyRound className="h-3.5 w-3.5" />{s.has_partner_key ? 'Rotate WHI key' : 'Create WHI key'}
        </button>
        <a href="/partner-desk/whi" target="_blank" rel="noreferrer" className="font-semibold text-emerald-700 underline" data-testid="admin-whi-desk-link">Open WHI Desk</a>
        {s.partner_key_rotated_at && <span className="text-slate-500">key set {new Date(s.partner_key_rotated_at).toLocaleDateString()}</span>}
      </div>
      {newKey && (
        <p className="mt-2 rounded-lg bg-amber-50 p-2 text-xs text-amber-800" data-testid="admin-whi-new-key">
          New WHI key (shown once; share securely with WHI): <code className="select-all font-bold">{newKey}</code>
        </p>
      )}
    </div>
  );
};
